export const ENTRY = 'entry'
export const REGISTRATION = 'registration'
export const SYSTEM = 'system'
export const INPUT = 'input'
export const ALL = 'all'

export default {
  [ENTRY]: {
    eventTypeId: [
      10,  // ToggleSwitch
      110, // FailedToggleSwitch
      201, // Switch1Toggle
      202, // Switch2Toggle
      203, // Switch3Toggle
      204, // Switch4Toggle
      205, // Switch1On
      206, // Switch2On
      207, // Switch3On
      208, // Switch4On
      209, // AllSwitchOn
      210, // Switch1Off
      211, // Switch2Off
      212, // Switch3Off
      213, // Switch4Off
      214  // AllSwitchOff
    ]
  },
  [REGISTRATION]: {
    eventTypeId: [
      4, // RequestRegistration
      5, // AcceptRegistration
      6, // DisableRegistration
      7, // DeleteRegistration
      9, // ActivateRegcode
      104, // FailedRequestRegistration
      105, // FailedAcceptRegistration
      106, // FailedDisableRegistration
      107, // FailedDeleteRegistration
      109, // FailedActivateRegcode
      7006, // PendingAccessSaved
      7007, // PendingAccessApproved
      7008 // MobileServerConnection
    ]
  },
  [SYSTEM]: {
    eventTypeId: [
      2, // SetControllerDescription
      3, // SetSwitchDescription
      11, // GetRegistrations
      12, // GetRegistrationDetails
      13, // GetLogEntries
      14, // GetDiagnosis
      15, // SetControllerTime
      16, // GetPublicStaticKey
      17, // GetUserInputType
      20, // SetWifiAuthentication
      21, // GetWifiAuthentication
      22, // GetWifiCert
      23, // SetWifiCert
      102, // FailedSetControllerDescription
      103, // FailedSetSwitchDescription
      111, // FailedGetRegistrations
      112, // FailedGetRegistrationDetails
      113, // FailedGetLogEntries
      114, // FailedGetDiagnosis
      115, // FailedSetControllerTime
      7000, // ExternalServerMessageSendingTimeout
      7001, // MqttMessageId
      7004, // ControllerMqttReconnection
      7005 // ControllerWifiReconnection
    ]
  },
  [INPUT]: {
    eventTypeId: [
      215, // OpenSensor
      216, // Dorbell
      217, // FireAlarm
      218, // SecurityAlarm
      219, // TermalSensor
      220, // MoveSensor
      221, // OtherSensor
      222  // Intrusion
    ]
  },
  [ALL]: {}
}



// WEBPACK FOOTER //
// ./src/components/event/profiles.js